// forEach pollyfill
if (typeof NodeList.prototype.forEach !== "function") {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

(() => {
    const stickyNav = document.querySelector(".sticky-nav");

    if (stickyNav) {
        function offset(el) {
            const rect = el.getBoundingClientRect(),
                scrollTop =
                    window.pageYOffset || document.documentElement.scrollTop;
            return {
                top: rect.top + scrollTop,
                bottom: rect.bottom + scrollTop
            };
        }

        const sectionProfiles = document.querySelector(".section-profiles");
        const divOffset = offset(sectionProfiles);
        const stickyNavItems = [...stickyNav.querySelectorAll("ul a")];

        if (stickyNavItems.length > 0) {
            stickyNavItems.map(navItem => {
                navItem.addEventListener("click", e => {
                    e.preventDefault();

                    stickyNavItems.map(navItem => {
                        navItem.classList.remove("active");
                    });

                    navItem.classList.add("active");

                    document
                        .querySelector(`[data-id="${navItem.dataset.href}"]`)
                        .scrollIntoView({
                            behavior: "smooth",
                            block: "start"
                        });
                
                    window.scrollTop += -90;
                });
            });
        }

        window.onscroll = function() {

            if (window.scrollY > 1125) {
                stickyNav.classList.add("sticky");

                if (window.scrollY > divOffset.bottom) {
                    stickyNav.classList.add("sticky-bottom");
                } else {
                    stickyNav.classList.remove("sticky-bottom");
                }

                if (stickyNavItems.length > 0) {
                    stickyNavItems.map(navItem => {
                        if (document
                                .querySelector(
                                    `[data-id="${
                                        navItem.dataset.href
                                    }"]`
                                )
                                .getBoundingClientRect().top < 500) {
                            stickyNavItems.map(navItem => {
                                navItem.classList.remove("active");
                            });

                            navItem.classList.add("active");
                        }
                    });
                }
            } else {
                stickyNav.classList.remove("sticky");
            }
        };
    }
})();
